module.exports = {
    parentLocale: 'da',
    relativeTime: {
        future: 'om %s',
        past: '%s',
        s: '1s',
        m: '1m',
        mm: '%dm',
        h: '1t',
        hh: '%dt',
        d: '1d',
        dd: '%dd',
        M: '1 dag siden',
        MM: '%d dage siden',
        y: '1å',
        yy: '%då',
    },
}
